import { render, staticRenderFns } from "./exerCollection.vue?vue&type=template&id=6159fd74&scoped=true&"
import script from "./exerCollection.vue?vue&type=script&lang=js&"
export * from "./exerCollection.vue?vue&type=script&lang=js&"
import style0 from "./exerCollection.vue?vue&type=style&index=0&id=6159fd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6159fd74",
  null
  
)

export default component.exports